// removed by extract-text-webpack-plugin
module.exports = {"languages":"Languages__languages___1S4SR","wrapper":"Languages__wrapper___36XJb","lang":"Languages__lang___2wS_3","flag":"Languages__flag___jaaXT","active":"Languages__active___2v7th"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Languages/Languages.css
// module id = 941
// module chunks = 0